export const INVENTORY_REFETCH_INTERVAL = 1000 * 60 * 15; // 15 minutes
